import axios from 'axios'
import GlobalVariable from './GlobalVariable.js'

const API_URL = GlobalVariable.baseUrl

axios.defaults.headers.common['X-App-Key'] = process.env.VUE_APP_API_KEY

export class APIService {
  // ── Menus (public) ───────────────────────────────────────────────────────
  getMenus () {
    return axios.get(`${API_URL}/user/menus`)
  }
  getPageByKey (key) {
    return axios.get(`${API_URL}/user/page/${key}`)
  }

  // ── Banners & Circulars ──────────────────────────────────────────────────
  getBanners () {
    return axios.get(`${API_URL}/user/banner`)
  }
  getCirculars () {
    return axios.get(`${API_URL}/user/circulars`)
  }
  getAdmissionCirculars (page) {
    return axios.get(`${API_URL}/user/circulars/admissions/${page}`)
  }

  // ── Events ───────────────────────────────────────────────────────────────
  getEvents () {
    return axios.get(`${API_URL}/user/events`)
  }
  getEventDetails (id) {
    return axios.get(`${API_URL}/user/event/${id}`)
  }
  getImages () {
    return axios.get(`${API_URL}/user/images_all`)
  }

  // ── Departments & Faculties ──────────────────────────────────────────────
  getDepartments () {
    return axios.get(`${API_URL}/user/departments`)
  }
  getDepartmentDetails (id) {
    return axios.get(`${API_URL}/user/department/${id}`)
  }
  getFaculties (id) {
    return axios.get(`${API_URL}/user/faculties/${id}`)
  }
  getAllFaculties () {
    return axios.get(`${API_URL}/user/faculties_all`)
  }
  getSubDepartments (id) {
    return axios.get(`${API_URL}/user/subjects/${id}`)
  }

  // ── Staff ────────────────────────────────────────────────────────────────
  getStaff () {
    return axios.get(`${API_URL}/user/staffs`)
  }

  // ── Scholarships ─────────────────────────────────────────────────────────
  getScholarships () {
    return axios.get(`${API_URL}/user/scholarships`)
  }

  // ── IQAC ─────────────────────────────────────────────────────────────────
  getIQAC () {
    return axios.get(`${API_URL}/user/iqac`)
  }
  getIQACByType (type) {
    return axios.get(`${API_URL}/user/iqac/${type}`)
  }

  // ── DVV Criteria ─────────────────────────────────────────────────────────
  getCriteria () {
    return axios.get(`${API_URL}/user/criteria`)
  }

  // ── Practical Fee ────────────────────────────────────────────────────────
  payFee (practicalJson) {
    return axios.post(`${API_URL}/user/practical_fee/pay`, practicalJson)
  }
  getFeeDetails (txnId) {
    return axios.get(`${API_URL}/user/practical_fee/${txnId}`)
  }
}
